import { validEmail } from '@/js/common/validate'

enum InputType {
  Text = 'text',
  Email = 'email'
}

export const validateForm = (selector: string = '.form-field-input'): boolean => {
  let isValid = true
  const elements = document.querySelectorAll(selector)
  elements.forEach((element) => {
    const input = element as HTMLInputElement
    const type = input.getAttribute('type')
    if (type === InputType.Email) {
      const validation = validEmail(input.value)
      if (validation) {
        input.classList.remove('error')
        input.classList.add('valid')
      } else {
        input.classList.remove('valid')
        input.classList.add('error')
      }
      isValid = validation
    } else if (type === InputType.Text) {
      const valueLength = input.value.length
      const validation = valueLength > 3 && valueLength < 30
      if (validation) {
        input.classList.remove('error')
        input.classList.add('valid')
      } else {
        input.classList.remove('valid')
        input.classList.add('error')
      }
      isValid = validation
    } else {
      const select = document.querySelector('.grade-field')
      if (select) {
        const value = input.getAttribute('value')
        const borderElement = select.children[1]
        if (!value) {
          borderElement.classList.add('error')
          borderElement.classList.remove('valid')
        } else {
          borderElement.classList.add('valid')
          borderElement.classList.remove('error')
        }
      }
    }
  })
  return isValid
}
